<template>

  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">

</style>

<script>
import "./assets/fontawesome/css/fontawesome.min.css";
export default {
  components: {
  }
};
</script>